var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import '../team-item/team-item.js';
import '../../watching-count/watching-count.js';
import '../../atoms/button/button.js';
import '../../atoms/icon/icon.js';
import '../../atoms/icon-button/icon-button.js';
import '../../comment/comment-form/comment-form.js';
import '@shoelace-style/shoelace/dist/components/avatar/avatar.js';
import '@shoelace-style/shoelace/dist/components/tooltip/tooltip.js';
import '@shoelace-style/shoelace/dist/components/card/card.js';
import { html } from 'lit';
import { customElement, property, query } from 'lit/decorators.js';
import { ifDefined } from 'lit/directives/if-defined.js';
import { styleMap } from 'lit/directives/style-map.js';
import { when } from 'lit/directives/when.js';
import { DateTime } from 'luxon';
import tinycolor from 'tinycolor2';
import { DateHelpers } from '../../helpers/dateHelpers.js';
import { getFullName, getInitials } from '../../helpers/nameHelpers.js';
import { SgdfElement } from '../../internal/sgdf-element.js';
import styles from './team-card.styles.js';
/**
 *  @status in-work
 */
let SgdfTeamCard = class SgdfTeamCard extends SgdfElement {
    constructor() {
        super(...arguments);
        this.teamEvents = [];
        this.noTeamLink = false;
        this.readOnly = true;
        this.viewType = 'list';
        this.onSelectMember = (member) => {
            var _a;
            this.emit('sgdf-select-entity', {
                detail: {
                    name: (_a = member.usage_first_name) !== null && _a !== void 0 ? _a : '',
                    type: 'participant',
                    id: member.id,
                },
            });
        };
        this.onQuickCommentClick = (member) => {
            var _a, _b, _c, _d;
            this.emit('sgdf-quick-comment:open', {
                detail: {
                    id: member.id,
                    first_name: (_a = member.first_name) !== null && _a !== void 0 ? _a : '',
                    last_name: (_b = member.last_name) !== null && _b !== void 0 ? _b : '',
                    usage_first_name: (_c = member.usage_first_name) !== null && _c !== void 0 ? _c : '',
                    usage_last_name: (_d = member.usage_last_name) !== null && _d !== void 0 ? _d : '',
                },
            });
        };
        this.onSelectTeam = () => {
            this.emit('sgdf-select-entity', {
                detail: {
                    name: this.team.label,
                    type: 'category' in this.team ? 'team' : 'daily-task-team',
                    id: this.team.id,
                },
            });
        };
    }
    tasksTriage() {
        const ownedTasks = this.teamEvents.filter(e => { var _a; return ((_a = e.team_in_charge) === null || _a === void 0 ? void 0 : _a.id) === this.team.id; });
        return ownedTasks
            .map(t => DateTime.fromJSDate(t.start_date))
            .map(sd => html `<div
                        class="team-card-event"
                        style=${styleMap({
            'grid-area': this.evtCoordinatesCSS(sd),
        })}
                    ></div>`);
    }
    evtCoordinatesCSS(evt) {
        var _a;
        const slots = [
            { hour: 20, top: 3 },
            { hour: 12, top: 2 },
            { hour: 0, top: 1 },
        ];
        const left = evt
            .diff(DateTime.fromJSDate(this.meetingStartDate), 'days')
            .rescale().days + 1;
        const top = ((_a = slots.find(s => s.hour <= evt.hour)) === null || _a === void 0 ? void 0 : _a.top) || 1;
        return `grid-area: ${left} / ${top} / ${left + 1} / ${top + 1}`;
    }
    renderMemberCard(member) {
        var _a, _b;
        const observationCount = (_b = (_a = this.observationCountByParticipant) === null || _a === void 0 ? void 0 : _a[member.id]) !== null && _b !== void 0 ? _b : null;
        const avatar_url = member.avatar_available
            ? member.avatar_url
            : member.user_avatar_available
                ? member.user_avatar_url
                : undefined;
        const initials = getInitials(member);
        if (this.viewType == 'photo') {
            return html `
                <sl-card class="sgdf-team-card-member">
                    <sl-avatar
                        class="avatar-trombi"
                        slot="image"
                        image=${ifDefined(avatar_url)}
                        .initials=${initials}
                        shape="square"
                    ></sl-avatar>
                    <div>${getFullName(member)}</div>
                    ${when(!this.readOnly, () => html ` <div>
                                    <small class="small"
                                        >${observationCount !== null && observationCount !== void 0 ? observationCount : 0}
                                        Observation</small
                                    >
                                </div>
                                <div slot="footer">
                                    <sgdf-button
                                        @click=${() => this.onSelectMember(member)}
                                    >
                                        <sgdf-icon
                                            name="eye"
                                            slot="prefix"
                                        ></sgdf-icon
                                        >Voir
                                    </sgdf-button>
                                    <sgdf-button
                                        @click="${() => this.onQuickCommentClick(member)}"
                                    >
                                        <sgdf-icon
                                            name="pen-nib"
                                            slot="prefix"
                                        ></sgdf-icon
                                        >Rédiger
                                    </sgdf-button>
                                </div>`)}
                </sl-card>
            `;
        }
        else {
            return html `
                <sl-card class="sgdf-team-card-member">
                    <div class="horizontal-flex">
                        <sl-avatar
                            image=${ifDefined(avatar_url)}
                            .initials=${initials}
                        ></sl-avatar>
                        <div class="sgdf-team-card-name">
                            ${getFullName(member)}
                            ${when(!this.readOnly, () => html ` <div>
                                        <small class="small"
                                            >${observationCount !== null && observationCount !== void 0 ? observationCount : 0}
                                            Observation</small
                                        >
                                    </div>`)}
                        </div>
                    </div>
                    ${when(!this.readOnly, () => html ` <div slot="footer">
                                <sgdf-button
                                    @click=${() => this.onSelectMember(member)}
                                >
                                    <sgdf-icon
                                        name="eye"
                                        slot="prefix"
                                    ></sgdf-icon
                                    >Voir
                                </sgdf-button>
                                <sgdf-button
                                    @click="${() => this.onQuickCommentClick(member)}"
                                >
                                    <sgdf-icon
                                        name="pen-nib"
                                        slot="prefix"
                                    ></sgdf-icon
                                    >Rédiger
                                </sgdf-button>
                            </div>`)}
                </sl-card>
            `;
        }
    }
    render() {
        var _a;
        return html `
            <div
                class="sgdf-team-card"
                style=${styleMap({
            '--team-color': this.team.color || '#00395c',
            '--meeting-length': DateHelpers.getAllDatesBetweenTwoDates({
                start: this.meetingStartDate,
                end: this.meetingEndDate,
            }).length.toString(),
        })}
            >
                <header
                    style=${styleMap({
            backgroundColor: this.team.color || '#00395c',
            color: tinycolor
                .mostReadable((_a = this.team.color) !== null && _a !== void 0 ? _a : '#00395c', [
                '#000',
                '#777',
                '#bbb',
                '#fff',
            ])
                .toHexString(),
        })}
                >
                    <div class="first-line">
                        <h3>${this.team.label}</h3>
                        ${when(!this.noTeamLink, () => {
            var _a;
            return html `<sl-tooltip content="Voir l'équipe">
                                    <sgdf-icon-button
                                        @click=${this.onSelectTeam}
                                        style=${styleMap({
                '--icon-color': tinycolor
                    .mostReadable((_a = this.team.color) !== null && _a !== void 0 ? _a : '#00395c', [
                    '#000',
                    '#777',
                    '#bbb',
                    '#fff',
                ])
                    .toHexString(),
            })}
                                        name="up-right-from-square"
                                    ></sgdf-icon-button>
                                </sl-tooltip>`;
        })}
                    </div>
                    <div class="sgdf-team-calendar">${this.tasksTriage()}</div>
                </header>
                <div class="sgdf-team-card-members">
                    ${this.team.participants.map(member => this.renderMemberCard(member))}
                </div>
            </div>
        `;
    }
};
SgdfTeamCard.styles = styles;
__decorate([
    property({ type: Object, reflect: true })
], SgdfTeamCard.prototype, "team", void 0);
__decorate([
    property({ type: Object, reflect: true })
], SgdfTeamCard.prototype, "observationCountByParticipant", void 0);
__decorate([
    property({ type: Array, reflect: true })
], SgdfTeamCard.prototype, "teamEvents", void 0);
__decorate([
    property({ type: Object, reflect: true })
], SgdfTeamCard.prototype, "meetingStartDate", void 0);
__decorate([
    property({ type: Object, reflect: true })
], SgdfTeamCard.prototype, "meetingEndDate", void 0);
__decorate([
    property({ type: Boolean, reflect: true, attribute: 'no-team-link' })
], SgdfTeamCard.prototype, "noTeamLink", void 0);
__decorate([
    property({ type: Boolean, reflect: true })
], SgdfTeamCard.prototype, "readOnly", void 0);
__decorate([
    property({ type: String, reflect: true })
], SgdfTeamCard.prototype, "viewType", void 0);
__decorate([
    query('#calendar')
], SgdfTeamCard.prototype, "calendarEl", void 0);
SgdfTeamCard = __decorate([
    customElement('sgdf-team-card')
], SgdfTeamCard);
export default SgdfTeamCard;
//# sourceMappingURL=team-card.js.map